import { useTranslation } from "react-i18next"
import { Grid, useTheme } from "@mui/material"

import { useAllPowerlines } from "helpers/hooks/powerlines/useAllPowerlines"
import TitleWithAvatar from "widgets/common/TitleWithAvatar"
import { HeaderContainer } from "widgets/styled/containers"
import PowerlineCardsSection from "./PowerlineCardsSection"
import PowerlinesTable from "./PowerlinesTable"

const PowerlinesContent = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { powerlines, isLoading, isError } = useAllPowerlines()

  return (
    <>
      <HeaderContainer>
        <TitleWithAvatar entity="powerline" title={t("powerlines.POWERLINES")} />
      </HeaderContainer>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <PowerlineCardsSection
            powerlines={powerlines}
            isLoading={isLoading}
            isError={Boolean(isError)}
          />
        </Grid>
        <Grid item xs={12}>
          <PowerlinesTable
            powerlines={powerlines}
            isLoading={isLoading}
            sx={{ border: `1px solid ${theme.palette.neutral[400]}` }}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default PowerlinesContent
